<template>
  <div>
    <v-btn outlined color="primary" class="mt-4 mr-2" @click="openFileDialog">
      <v-icon left>mdi-file-excel</v-icon>
      Upload Excel
    </v-btn>
    <v-btn outlined color="secondary" class="mt-4" @click="downloadTemplate">
      <v-icon left>mdi-download</v-icon>
      Tải xuống file mẫu
    </v-btn>
    <input type="file" ref="fileInput" style="display: none" @change="handleFileUpload" accept=".xlsx, .xls" />
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import moment from 'moment'

export default {
  name: 'UploadExcelForFreeSchedule',
  methods: {
    openFileDialog() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })

        this.processExcelData(jsonData)
      }

      reader.readAsArrayBuffer(file)
    },
    processExcelData(data) {
      const [, ...rows] = data

      const schedules = rows.map((row) => ({
        date: this.formatDate(row[0]),
        startTime: this.formatTime(row[1]),
        endTime: this.formatTime(row[2]),
        classroom: {
          id: row[3],
          name: row[4],
        },
      }))

      this.$emit('upload-schedules', schedules)
    },
    formatDate(excelDate) {
      if (typeof excelDate === 'string') {
        const [day, month, year] = excelDate.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      }
      const date = new Date((excelDate - 25569) * 86400 * 1000)
      return moment(date).format('YYYY-MM-DD')
    },
    formatTime(excelTime) {
      if (typeof excelTime === 'string') {
        return excelTime // If it's already a string, assume it's in the correct format
      }
      if (typeof excelTime !== 'number' || isNaN(excelTime)) {
        return '00:00' // Return a default value if the input is invalid
      }
      const totalSeconds = Math.round(excelTime * 86400)
      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
    },
    downloadTemplate() {
      const templateData = [
        ['Ngày', 'Giờ bắt đầu', 'Giờ kết thúc', 'ID Phòng học', 'Tên Phòng học'],
        ['01/05/2023', '08:00', '09:30', 'R001', 'Phòng 1'],
        ['02/05/2023', '10:00', '11:30', 'R002', 'Phòng 2'],
      ]

      const ws = XLSX.utils.aoa_to_sheet(templateData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Template')

      XLSX.writeFile(wb, 'template_free_schedule.xlsx')
    },
  },
}
</script>
